
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface PrivacyPolicyModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const PrivacyPolicyModal = ({ open, onOpenChange }: PrivacyPolicyModalProps) => {
  const { t } = useTranslation();

  const collectedItems = t('privacy.section2.items', { returnObjects: true }) as string[];
  const purposeItems = t('privacy.section3.items', { returnObjects: true }) as string[];
  const thirdPartyItems = t('privacy.section4.items', { returnObjects: true }) as string[];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold">{t('privacy.title')}</DialogTitle>
          <DialogDescription>
            {t('privacy.lastUpdated')}
          </DialogDescription>
        </DialogHeader>

        <div className="text-left space-y-4 mt-4">
          <h3 className="text-lg font-semibold">{t('privacy.section1.title')}</h3>
          <p>{t('privacy.section1.body')}</p>

          <h3 className="text-lg font-semibold">{t('privacy.section2.title')}</h3>
          <p>{t('privacy.section2.body')}</p>
          <ul className="list-disc pl-6">
            {Array.isArray(collectedItems) && collectedItems.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>

          <h3 className="text-lg font-semibold">{t('privacy.section3.title')}</h3>
          <p>{t('privacy.section3.body')}</p>
          <ul className="list-disc pl-6">
            {Array.isArray(purposeItems) && purposeItems.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>

          <h3 className="text-lg font-semibold">{t('privacy.section4.title')}</h3>
          <p>{t('privacy.section4.body')}</p>
          <ul className="list-disc pl-6">
            {Array.isArray(thirdPartyItems) && thirdPartyItems.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>

          <h3 className="text-lg font-semibold">{t('privacy.section5.title')}</h3>
          <p>{t('privacy.section5.body')}</p>

          <h3 className="text-lg font-semibold">{t('privacy.section6.title')}</h3>
          <p>{t('privacy.section6.body')}</p>

          <h3 className="text-lg font-semibold">{t('privacy.section7.title')}</h3>
          <p>{t('privacy.section7.body')}</p>

          <h3 className="text-lg font-semibold">{t('privacy.section8.title')}</h3>
          <p>{t('privacy.section8.body')}</p>

          <h3 className="text-lg font-semibold">{t('privacy.section9.title')}</h3>
          <p>{t('privacy.section9.body')}</p>
          <div className="mt-2">
            <div>{t('privacy.contact.company')}</div>
            <div>{t('privacy.contact.address')}</div>
            <div>{t('privacy.contact.email')}</div>
            <div>{t('privacy.contact.phone')}</div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
